/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'react-toastify/dist/ReactToastify.css';

import CN from 'classnames';
import { Header } from 'components/common/Header';
import { SideBar } from 'components/common/SideBar';
import { useGetVerifyUserToken } from 'framework/api/methods';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { setUserDetails } from 'store/reducers/user/userSlice';
// import { setUserDetails } from 'store/reducers/user/userSlice';

export interface MainLayoutProps {
  [x: string]: any;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }: MainLayoutProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlLocation = useLocation();

  const { userDetails }: any = useSelector<any>((state) => state.user);
  const { isLogOutModalOpen }: any = useSelector<any>((state) => state.user);
  const [isActiveLogoutModal, setIsActiveLogoutModal] = useState(isLogOutModalOpen);
  const firstRoute = urlLocation.pathname.split('/')[1];
  const token = localStorage.getItem('token');

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    setIsActiveLogoutModal(isLogOutModalOpen);
  }, [token, isLogOutModalOpen]);

  const onSuccessVerifyToken = (data: any) => {
    dispatch(setUserDetails({ name: data?.userData, status: data?.userStatus }));
  };

  const onErrorVerifyToken = (data: any) => {
    notify('Session expired.', 'error');
    setTimeout(() => {
      navigate('/auth/login');
      localStorage.clear();
    }, 2000);
  };

  /** Get all cards API */
  const { refetch: getVerifyToken } = useGetVerifyUserToken(
    onSuccessVerifyToken,
    onErrorVerifyToken,
    false,
  );

  useEffect(() => {
    if (token) {
      getVerifyToken();
    }
  }, [token]);

  const initialObj = [
    {
      mainMenuId: 0,
      mainMenuItemKey: Math.random(),
      name: 'Dashboard',
      url: '/',
      icon: <i className="ri-line-chart-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 1,
      mainMenuItemKey: Math.random(),
      name: 'Videos',
      url: '/videos',
      icon: <i className="ri-video-on-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
  ];

  return (
    <div className="w-full h-screen">
      {/* <SideBar firstRoute={firstRoute} menuItemList={initialObj} userDetails={userDetails} /> */}

      <div
        className={CN(
          'main-layout__content z-10 fixed h-full left-0 w-full bg-[#f4f4f4]', // F9FAFB
        )}
      >
        <Header userDetails={userDetails} firstRoute={firstRoute} menuItemList={initialObj} />
        <div className="h-[calc(100%-70px)] w-full">
          {children}
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            className="toast-container"
          />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
